export const UserRouter = [
  {
    path: '/my-data',
    name: 'MyData',
    component: () => import('../../views/user/MyData')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../../views/user/Profile')
  },
  {
    path: '/my-favorites',
    name: 'MyFavorites',
    component: () => import('../../views/user/Favorites')
  },
  {
    path: '/users/:id/favorites',
    name: 'UserFavorites',
    component: () => import('../../views/user/Favorites')
  },
  {
    path: '/auth/sign-up',
    name: 'SignUp',
    component: () => import('../../views/auth/SignUp')
  }
];